export enum UserStatus {
  NOTVERIFIED = 'notVerified',
  AUTHENTICATED = 'authenticated',
  INCOMPLETE = 'incomplete',
}
